import { ofType } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { mergeMap, withLatestFrom } from 'rxjs/operators';
import checklistConnectedActions from '@bridebook/web/lib/connected-actions/checklist';
import { Action, IApplicationState, IEpicDeps } from '@bridebook/web/lib/types';

const { checklistActionsHandler, checklistConnectedActionTypes } = checklistConnectedActions;

export const connectedActionsEpic = (action$: Observable<Action>, { state$ }: IEpicDeps) =>
  action$.pipe(
    ofType(...checklistConnectedActionTypes),
    withLatestFrom(state$),
    mergeMap(([action, state]: [Action, IApplicationState]) => {
      if (checklistConnectedActionTypes.includes(action.type)) {
        return of(...checklistActionsHandler(action, state));
      }

      return of();
    }),
  );
